import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=243bede0&scoped=true"
import script from "./CreateDialog.ts?vue&type=script&lang=ts&external"
export * from "./CreateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./create-dialog.scss?vue&type=style&index=0&id=243bede0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243bede0",
  null
  
)

export default component.exports